import React, { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router-dom";
import { ErrorMessage } from "sprint-common-web";

import { PreviewLoadingError } from "./PreviewLoadingError";

interface CloudFileFilePreviewErrorBoundaryProps {
    children: ReactNode;
}

const CloudFileFilePreviewErrorFallback: React.FC<{ error: Error }> = ({ error }) => {
    const decoratedMessage = `Preview error: ${error.message}`;

    if (error instanceof PreviewLoadingError) {
        return <ErrorMessage text={decoratedMessage} />;
    }

    return <ErrorMessage stack={String(error.stack)} text={decoratedMessage} />;
};

export const CloudFileFilePreviewErrorBoundary: React.FC<CloudFileFilePreviewErrorBoundaryProps> = ({ children }) => {
    const location = useLocation();

    return (
        <ErrorBoundary key={location.pathname} FallbackComponent={CloudFileFilePreviewErrorFallback}>
            {children}
        </ErrorBoundary>
    );
};
